<template>
  <b-modal v-model="showModal">
    <div slot="modal-title">
      {{ $t('message.subscription.all_bookings') }}
    </div>
    <section>
      <template v-for="order in orders">
        <div class="card shadow-sm">
          <div class="card-body px-0">

            <div class="row">
              <div class="col-2 text-center">
                <h5>{{ getFormattedDate(order.cleaning_date, 'D') }}</h5>
                <h4>{{ getFormattedDate(order.cleaning_date, 'MMM') }}</h4>
              </div>
              <div class="col-10">
                <div>
                  #{{ order.order_code }}
                  -
                  <span v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span>
                </div>
                <div>
                  {{ order.work_hour }} {{ $tc('message.hour', order.work_hour) }} • {{ order | duration }}
                </div>
                <div class="mt-2 d-flex  align-items-center" v-if="order.professional">
                  <img :src="order.professional.full_picture"
                       class="rounded-circle mr-3" width="42">
                  <div>{{ order.professional.full_name | firstName }}</div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 text-right">
                <span class="badge badge-pill py-2 px-3"
                      :class="(order.status < 2) ? 'badge-warning' : 'badge-success'">
                  {{ (order.status < 2) ? $t('message.my_reservations.upcoming') : $t('message.order_status.completed') }}
                </span>
              </div>
            </div>

          </div>
        </div>
      </template>
    </section>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button variant="secondary" @click="cancel()">
        {{ $t('message.button.close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment-timezone'

  export default {
    data () {
      return {
        showModal: false,
        orders: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        orderDetail: 'orderDetail/getOrderDetail'
      })
    },
    methods: {
      showSubscriptionOrdersModal (status) {
        this.showModal = status
        if (status) {
          if (this.orderDetail.subscription_id) {
            this.orders = this.orderDetail.subscription.orders
          } else if (this.orderDetail.package_id) {
            this.orders = this.orderDetail.package.orders
          }
        }
      },
      getFormattedDate (date, format) {
        return moment(date).format(format)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/SubscriptionOrdersModal.vue